import { createRouter, createWebHashHistory  } from 'vue-router';
import PlanView from '../views/PlanView.vue';
import LoginView from '../views/LoginView.vue';
import DashBoard from '../views/DashBoardView.vue';
import Resources from '../views/ResourcesView.vue';

const routes = [
  { path: '/', component: PlanView },
  { path: '/login', component: LoginView },
  { path: '/DashBoard', component: DashBoard },
  { path: '/Resources', component: Resources }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
